import { render, staticRenderFns } from "./WaitItem.vue?vue&type=template&id=c15896ba&scoped=true&"
import script from "./WaitItem.vue?vue&type=script&lang=js&"
export * from "./WaitItem.vue?vue&type=script&lang=js&"
import style0 from "./WaitItem.vue?vue&type=style&index=0&id=c15896ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15896ba",
  null
  
)

export default component.exports